/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserStatus } from '../../models/user-status';

export interface ExportUsersReport$Params {

/**
 * Search user reports by email, full name, EPN, designation
 */
  search?: string;

/**
 * Filter by user status
 */
  status?: Array<UserStatus>;
  sort?: string;
  applications?: Array<string>;
}

export function exportUsersReport(http: HttpClient, rootUrl: string, params?: ExportUsersReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportUsersReport.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('status', params.status, {});
    rb.query('sort', params.sort, {});
    rb.query('applications', params.applications, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportUsersReport.PATH = '/api/administration/reports/users/export';
